export default function archivedReportInstancesDirective() {
  return {
    template: require('./report-instances.html'),
    controller: 'ArchivedReportInstancesController',
    controllerAs: 'archivedReportInstancesVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '@',
      reportInstances: '=',
    },
  };
}
